export default __webpack_public_path__ + "static/media/team.738b3543.png";